import Resource from '@/plugins/sdk/Resource'
import { UUID, ARRAY } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'consignment_item'

  static get fields () {
    return {
      id: new UUID(),
      features: new ARRAY()
    }
  }
}
